import callApi from "@repo/next-shared/utils/api";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { Size } from "@/types/size";
import { objToQueryParams } from "@repo/next-shared/utils";

export async function getSizes(categoryId: string) {
  return await callApi({
    path: `/catalog/size?${objToQueryParams({ categoryId })}`,
    method: "GET",
  });
}

export function useSizesBase(categoryId: string, select: any): any {
  return useQuery({
    queryKey: ["sizes", categoryId],
    queryFn: () => getSizes(categoryId),
    select,
    staleTime: 60000 * 60,
  });
}

export function useSizes(categoryId: string): UseQueryResult<Size[], any> {
  return useSizesBase(categoryId, (sizes: Size[]) => sizes);
}
